export type PriceFetchTarget = 'ana' | 'jal' | 'skyticket' | 'travelko';

export const ANA_SOURCE_PREFIX = 'ana_official';
export const JAL_SOURCE_PREFIX = 'jal_official';
export const SCRAPED_SOURCE_PREFIXES: PriceFetchTarget[] = ['skyticket', 'travelko'];

// バックエンドの SearchRouteResolverService と同じ前方一致で取得元を判定する
// ANAとJALが混在する場合はバックエンドと同じくANAを優先する
export const resolvePriceFetchTarget = (sources: string[]): PriceFetchTarget | null => {
  if (sources.some(s => s.startsWith(ANA_SOURCE_PREFIX))) return 'ana';
  if (sources.some(s => s.startsWith(JAL_SOURCE_PREFIX))) return 'jal';
  return SCRAPED_SOURCE_PREFIXES.find(prefix => sources.some(s => s.startsWith(prefix))) ?? null;
};

export type ScrapedFetchTarget = Exclude<PriceFetchTarget, 'ana' | 'jal'>;

export const isScrapedFetchTarget = (target: PriceFetchTarget | null): target is ScrapedFetchTarget =>
  target != null && target !== 'ana' && target !== 'jal';

// ai-operatorがオンデマンドで再取得できるキャッシュ（domestic_air_flight_caches）由来の取得元
export type CacheFetchTarget = Extract<PriceFetchTarget, 'ana' | 'jal'>;

export const CACHE_SOURCE_PREFIXES: Record<CacheFetchTarget, string> = {
  ana: ANA_SOURCE_PREFIX,
  jal: JAL_SOURCE_PREFIX
};

export const isCacheFetchTarget = (target: PriceFetchTarget | null): target is CacheFetchTarget =>
  target === 'ana' || target === 'jal';
